module.exports = __webpack_public_path__ + "static/media/linkedin.ef36da23.svg";